module.exports = __webpack_public_path__ + "static/media/SWSCRC1-37.2132bac1.mp3";